import { ValidationService } from './../../services/validation.service';
import { FormControl } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-validation-message',
  templateUrl: './validation-message.component.html',
  styleUrls: ['./validation-message.component.css']
})
export class ValidationMessageComponent implements OnInit {
  @Input() control: FormControl;
  // @Input() submitForm: boolean;
  @Input() field: string;

  constructor() {}

  ngOnInit() {}

  get errorMessage() {
    if (this.control !== undefined) {
      for (const propertyName in this.control.errors) {
        // if (this.control.errors.hasOwnProperty(propertyName) && this.control.touched) {
        if (this.control.errors.hasOwnProperty(propertyName)) {
          // return ValidationService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);

          const message = ValidationService.getValidatorErrorMessage(
            propertyName,
            this.control.errors[propertyName]
          );
          return this.field + message;
        }
      }
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/login/validation-message/validation-message.component.ts